import React from 'react';
import { Button, FlexRow, FormCell, Grid, Header3Text } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { IPayoffRequestData } from '../../../types/order/title/IPayoffRequest';
import { eTitleSearchStatus, prettyVendorStatus } from '../../../types/order/title/eTitleSearchStatus';
import { IconType, Notification, RotatingIcon } from 'ui-toolkit';
import { DateFormat, getDateString } from '../../../ui-toolkit/utilities/getDateString';

export interface IPayoffRequestComponentComponentProps {
  payoffs: IPayoffRequestData[];
  onCreatePayoff: () => void;
  onCancelPayoff: (payoffId: string) => void;
  createFetchStatus: IFetchStatus;
  cancelFetchStatus: IFetchStatus;
  cancelPayoffError: string | null;
  createPayoffError: string | null;
}

export const PayoffRequestComponent: React.FC<IPayoffRequestComponentComponentProps> = ({
  onCreatePayoff,
  payoffs,
  onCancelPayoff,
  createFetchStatus,
  cancelFetchStatus,
  cancelPayoffError,
  createPayoffError,
}) => {
  const lastPayoff: IPayoffRequestData | undefined = payoffs
    .slice()
    .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
    .filter((p) => p.status !== eTitleSearchStatus.cancelled && p.status !== eTitleSearchStatus.accepted)
    .shift();
  return (
    <Grid>
      {createFetchStatus.fetching || cancelFetchStatus.fetching ? <RotatingIcon type={IconType.Loading} /> : null}
      {cancelPayoffError || createPayoffError ? (
        <Notification type={'error'} message={cancelPayoffError || createPayoffError} />
      ) : null}
      {lastPayoff ? (
        <>
          <FormCell hintText={`ETA: ${lastPayoff.eta ? getDateString(DateFormat.long, lastPayoff.eta) : ''}`}>
            <Header3Text>Payoff {prettyVendorStatus[lastPayoff.status]}</Header3Text>
          </FormCell>
          {[eTitleSearchStatus.new, eTitleSearchStatus.inProgress].includes(lastPayoff.status) ? (
            <FlexRow>
              <Button
                intent={'primary'}
                onClick={() => onCancelPayoff(lastPayoff.id)}
                disabled={cancelFetchStatus.fetching}
              >
                Cancel Payoff Order
              </Button>
            </FlexRow>
          ) : lastPayoff.status === eTitleSearchStatus.sent ? (
            <FlexRow>
              <Button intent={'primary'} onClick={onCreatePayoff} disabled={createFetchStatus.fetching}>
                Order Payoff from KSS
              </Button>
            </FlexRow>
          ) : null}
        </>
      ) : (
        <>
          <Header3Text>Payoff</Header3Text>
          <FlexRow>
            <Button intent={'primary'} onClick={onCreatePayoff} disabled={createFetchStatus.fetching}>
              Order Payoff from KSS
            </Button>
          </FlexRow>
        </>
      )}
    </Grid>
  );
};
